import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useWarehouseContext } from 'providers/WarehouseProvider';

import Table from 'components/common/Table';

import { picklistApi, shipmentApi } from 'api';

import paths from 'routes/paths';
import {
  CREATE_PICKLIST_LIST_TAB,
  CREATE_PICKLIST_LIST_COLUMNS,
  CREATE_PICKLIST_FILTER_OPTIONS,
} from 'constants/picklist';

const CreatePickList = () => {
  const navigate = useNavigate();

  const { selectedWarehouse } = useWarehouseContext();
  const initialFilter = { warehouse: selectedWarehouse?.id };

  const handleCreatePicklist = useCallback(
    async selectedRows => {
      const shipmentIds = selectedRows.map(row => row.id);

      const response = await picklistApi.create({
        warehouse: selectedWarehouse?.id,
        shipment_id_list: shipmentIds,
      });

      return {
        result: response,
        shouldRefetch: false,
      };
    },
    [selectedWarehouse],
  );

  const bulkActions = [
    {
      value: 'create_picklist',
      label: 'Create Picklist',
      variant: 'primary',
      successMessage: 'Successfully create picklist',
      errorMessage: 'Fail to create picklist',
      handler: handleCreatePicklist,
      onSuccess: response => {
        if (response?.result?.id !== null) {
          navigate(
            `${paths.picklistDetails(response.result.id)}?tab=shipments`,
          );
        }
      },
    },
  ];

  return (
    <Table
      title="Manual PickList"
      apiService={shipmentApi}
      sortable={true}
      columns={CREATE_PICKLIST_LIST_COLUMNS}
      filterOptions={CREATE_PICKLIST_FILTER_OPTIONS}
      initialPageSize={50}
      tabOptions={CREATE_PICKLIST_LIST_TAB}
      initialFilter={initialFilter}
      bulkActions={bulkActions}
      fetchConfig={{
        method: 'getShipmentsForCreatePicklist',
      }}
    />
  );
};

export default CreatePickList;
